import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import MapEditor from './editor';

// Thin drawer wrapper around MapEditor for the feed composer's `/kart`
// slash command — same shape as fishCatch/drawer.js: local working state,
// the extracted editor, and Lagre/Avbryt buttons.
//
// MapEditor's onChange only ever hands back the key(s) that actually
// changed (see the comment in components/map/editor.js), so merging it
// straight into local state with setState(changed) is safe and keeps a
// zoom/coordinate of 0 intact — never coerce it with a truthy check.
@observer
class MapDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapMarkers: props.mapMarkers || [],
            // A zoom of 0 is a real, legitimate value - only fall back to
            // the default of 13 when it's genuinely absent.
            mapZoom: Number.isFinite(props.mapZoom) ? props.mapZoom : 13,
            mapCenter: props.mapCenter || null,
        };
    }

    handleChange = (changed) => {
        this.setState(changed);
    }

    saveMap = () => {
        const { onSave, drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { mapMarkers, mapZoom, mapCenter } = this.state;
        onSave({ mapMarkers, mapZoom, mapCenter });
        if (appState?.toggleDrawer) {
            appState.toggleDrawer(false, drawerLevel);
        }
    }

    cancelMap = () => {
        const { onCancel, drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        onCancel();
        if (appState?.toggleDrawer) {
            appState.toggleDrawer(false, drawerLevel);
        }
    }

    render() {
        const { stores } = this.props;
        const { mapMarkers, mapZoom, mapCenter } = this.state;

        return (
            <div class='map-drawer'>
                <div class='w-100 d-flex justify-content-center'>
                    <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                        <div class='font-weight-lighter px-3 box-header mt-0'>
                            <Text id='map.title'>Add map</Text>
                        </div>

                        <div class='px-3 mt-2'>
                            <div class='card'>
                                <div class='card-body'>
                                    <MapEditor
                                        stores={stores}
                                        mapMarkers={mapMarkers}
                                        mapZoom={mapZoom}
                                        mapCenter={mapCenter}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class='w-100 d-flex justify-content-end mt-3 px-4 py-3 bg-body-secondary fixed-bottom'
                    style='bottom: 0; left: 0;'
                >
                    <button
                        type='button'
                        class='btn btn-outline-secondary rounded-pill me-2'
                        data-testid='map-cancel'
                        onClick={this.cancelMap}
                    >
                        <i class='fa-solid fa-xmark me-1' />
                        <Text id='map.cancel'>Cancel</Text>
                    </button>
                    <button
                        type='button'
                        class='btn btn-primary rounded-pill'
                        data-testid='map-save'
                        onClick={this.saveMap}
                    >
                        <i class='fa-solid fa-check me-1' />
                        <Text id='map.save'>Save</Text>
                    </button>
                </div>
            </div>
        );
    }
}

export default MapDrawer;
